import _ from "lodash";
import React from "react";
import { useForm, Controller } from "react-hook-form";
import { toast } from "react-toastify";
import styled from "styled-components";

import { Button } from "@components/Button";
import ErrorValidate from "@components/ErrorValidate";
import { StyledInput } from "@components/Input";
import { Text } from "@components/Text";
import { COLOR_DARK, COLOR_GREEN, COLOR_WHITE } from "@static/COLORS";
import { fetchAPI } from "@utils/https/fetchAPI";
import { VALIDATE_RULES } from "@validate/index";

const FormContainer = styled.form`
  width: 100%;
  height: 100%;
  display: flex;
  position: relative;
  flex-direction: column;
  gap: 2px;
`;

const Line = styled.div`
  width: 100%;
  height: 1px;
  margin-bottom: 8px;
  background-color: rgba(0, 0, 0, 0.1);
`;

const InnerContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  flex-grow: 1;
`;

const ButtonContainer = styled.div`
  display: flex;
  justify-content: center;
  height: 40px;
`;

export const FormCreate = ({
  setDataList = () => undefined,
  setIsModalVisible,
  dataList,
}) => {
  const { control, handleSubmit } = useForm();

  const onHandleCreate = async (data) => {
    const name = _.get(data, ["name"]);
    const email = _.get(data, ["email"]);
    console.log("email :>> ", email);
    const resp = await fetchAPI({
      method: "post",
      path: "/api/v1/customer-create",
      isAuth: true,
      data: {
        customer_name: name,
        email: email,
      },
    });
    if (_.get(resp, ["status"])) {
      const results = _.chain(resp).get(["result"]).value();
      toast.success("Create Customer Success.");
      setIsModalVisible((prev) => ({ ...prev, isOpen: false }));
      const updateData = _.chain(dataList)
        .thru((list) => {
          return [results, ...list];
        })
        .map((item, index) => {
          return { ...item, key: index + 1, index: index + 1 };
        })
        .value();
      setDataList(updateData);
    }
  };

  return (
    <FormContainer onSubmit={handleSubmit(onHandleCreate)} autoComplete="off">
      <Line />
      <InnerContainer>
        <div>
          <Controller
            name="name"
            control={control}
            rules={_.get(VALIDATE_RULES, ["required"])}
            render={({ field, fieldState: { error } }) => (
              <div>
                <Text
                  color={COLOR_DARK}
                  fontSize="14px"
                  style={{ marginBottom: 4, marginLeft: 4 }}
                >
                  Name
                </Text>
                <StyledInput
                  label="name"
                  {...field}
                  size="large"
                  placeholder="name"
                />
                <ErrorValidate justify="start" error={error} />
              </div>
            )}
          />
          <Controller
            name="email"
            control={control}
            rules={_.get(VALIDATE_RULES, ["required"])}
            render={({ field, fieldState: { error } }) => (
              <div>
                <Text
                  color={COLOR_DARK}
                  fontSize="14px"
                  style={{ marginBottom: 4, marginLeft: 4 }}
                >
                  Email
                </Text>
                <StyledInput
                  label="email"
                  {...field}
                  size="large"
                  placeholder="email"
                />
                <ErrorValidate justify="start" error={error} />
              </div>
            )}
          />
        </div>

        <ButtonContainer>
          <Button
            type="submit"
            color={COLOR_GREEN}
            fontColor={COLOR_WHITE}
            fontSize="16px"
            padding="5px 20px"
          >
            Save
          </Button>
        </ButtonContainer>
      </InnerContainer>
    </FormContainer>
  );
};
